import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyDpFMX38zIhfGGBMPv0Ru_uV_EArgf_HnI",
  authDomain: "chat-application-cff52.firebaseapp.com",
  databaseURL: "https://chat-application-cff52.firebaseio.com",
  projectId: "chat-application-cff52",
  storageBucket: "chat-application-cff52.appspot.com",
  messagingSenderId: "21282719497",
  appId: "1:21282719497:web:3740d85b06d39f8f4875d8"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export {auth, db, storage};